import React, { useState, useEffect } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Link, useNavigate } from 'react-router-dom';
import * as Icon from 'react-feather';
import { useSelector, useDispatch } from 'react-redux';
import UsersModal from '../../feature-module/admin/common/modals/users-modal';
import { rowdatas } from '../../core/models/interface';
import {
  getAllAdminUsers,
  updateAdminUser,
} from '../../services/adminServices';
import { toast } from 'react-toastify';
import { AppDispatch } from '../../core/data/redux/store';
import Loading from '../../feature-module/components/loading';
import { UserRoles } from '../common/constants/userRoles';

const ListUsers = () => {
  const dispatch = useDispatch<AppDispatch>();
  const data = useSelector((state: any) => state.users);
  const {
    allUsers,
    isError,
    isLoading,
    errorMessage,
    adminUserCreated,
    adminUserUpdated,
  } = useSelector((state: any) => ({
    allUsers: state.admin.adminUsers,
    isError: state.admin.isError,
    isLoading: state.admin.isLoading,
    errorMessage: state.admin.errorMessage,
    adminUserCreated: state.admin.adminUserCreated,
    adminUserUpdated: state.admin.adminUserUpdated,
  }));

  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedUser, setSelectedUser] = useState<rowdatas | null>(null);
  const handleDelete = (data: any) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      dispatch(updateAdminUser(accessToken, data, setIsEditModalOpen, true));
    }
  };

  const handleEdit = (rowData: rowdatas) => {
    setSelectedUser(rowData);
    setIsEditModalOpen(true);
  };

  const actionButton = (rowData: rowdatas) => {
    return (
      <div className="table-actions d-flex justify-content-center">
        <Link
          className="delete-table me-2"
          to="#"
          data-bs-toggle="modal"
          data-bs-target="#edit-user"
          onClick={() => handleEdit(rowData)}
        >
          <Icon.Edit className="react-feather-custom" />
        </Link>
        <Link
          className="delete-table"
          to="#"
          onClick={() =>
            handleDelete({ ...rowData, is_active: false, is_deleted: true })
          }
        >
          <Icon.Trash2 className="react-feather-custom" />
        </Link>
      </div>
    );
  };

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = localStorage.getItem('userRole');
    if (userRole !== UserRoles.SUPER_ADMIN) {
      navigate('/');
      toast.error('Bu sayfaya erişim yetkiniz bulunmamaktadır.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [navigate]);

  useEffect(() => {

    dispatch(getAllAdminUsers());
    
    return () => {
      dispatch({ type: 'RESET_ADMIN_ERRORS' });
    };
  }, [dispatch, adminUserCreated, adminUserUpdated]);

  // useEffect(() => {
  //   if (isError) {
  //     toast.error(errorMessage || 'Bir Hata Oluştu', {
  //       position: 'top-right',
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //   }
  // }, [isError, errorMessage]);

  const renderCustomerNameColumn = (rowData: rowdatas) => {
    return (
      <div className="table-profileimage">
        <div className="ml-2"></div>

        <div className="ml-2">
          {rowData.username && <span>{rowData.username.split('\n')[0]}</span>}
          <br />
          {rowData.username && <span>{rowData.username.split('\n')[1]}</span>}
        </div>
      </div>
    );
  };

  function formatDate(dateString: string): string {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  }
  

  return (
    <>
      <div className="page-wrapper page-settings" style={{ paddingTop: '0px' }}>
        <div className="content">
          <div className="content-page-header content-page-headersplit">
            <h5>Kullanıcılar</h5>
            <div className="list-btn">
              <ul>
                <li>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => setIsAddModalOpen(true)}
                  >
                    <i className="fa fa-plus me-2" />
                    Kullanıcı Ekle
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-12 ">
              <div className="table-resposnive">
                <DataTable
                  value={allUsers}
                  showGridlines
                  tableStyle={{ minWidth: '50rem' }}
                  emptyMessage={isLoading ? <Loading /> : 'Kayıt Bulunamadı'}
                >
                  <Column
                    header="#"
                    body={(data, options) => options.rowIndex + 1}
                  ></Column>
                  <Column
                    sortable
                    field="username"
                    header="Kullanıcı Adı"
                    body={renderCustomerNameColumn}
                  ></Column>

                  <Column
                    sortable
                    field="role"
                    header="Rol"
                    body={(rowData) => {
                      if (rowData.role ===UserRoles.SUPER_ADMIN) {
                        return 'Super Admin';
                      } else if (rowData.role === 'admin') {
                        return 'Admin';
                      }
                      return rowData.role;
                    }}
                  ></Column>
                  <Column
                    sortable
                    field="created"
                    header="Oluşturulma Tarihi"
                    body={(rowData) => {
                      return formatDate(rowData.created_at.split('T')[0]);
                    }}
                  ></Column>
                  <Column
                    sortable
                    field="status"
                    header="Durum"
                    body={(rowData) => (
                      <span
                        className={
                          rowData.is_active === true ? 'badge-active' : 'badge-inactive'
                        }
                      >
                        {rowData.is_active === true ? 'Aktif' : 'Pasif'}
                      </span>
                    )}
                  ></Column>
                  <Column
                    field="action"
                    header="Aksiyon"
                    body={actionButton}
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UsersModal
        selectedUser={selectedUser}
        setIsAddModalOpen={setIsAddModalOpen}
        isAddModalOpen={isAddModalOpen}
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
      />
    </>
  );
};

export default ListUsers;
